module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-02@2x-05a42bd6d5164ba4ada4df55aec98151.png";